export default __webpack_public_path__ + "img/how-to-use-slide04.64021e58.webp";